import { css } from 'lit';

export const styles = css`:host{--component-size: var(--ig-size, var(--default-size));color:var(--color)}svg{fill:currentcolor}igc-icon,svg{font-size:var(--size)}`;
